var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.19548,
    y: -1.20271,
    width: 54.2024,
    height: 54.2024,
    rx: 14.7888,
    transform: "matrix(0.999995 0.0030212 -0.00300305 0.999995 2.50932 2.36079)",
    fill: "black",
    stroke: "url(#paint0_linear_130_95)",
    strokeWidth: 2.39818
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2415 43.5314L43.4535 40.3387C43.0797 38.7898 41.9362 37.5417 40.4259 37.0342L34.5828 35.0677C33.1582 34.4692 32.5124 32.1702 32.3741 31.2977C33.4637 30.3972 34.1669 29.1135 34.339 27.7105C34.3158 27.4707 34.3731 27.23 34.5019 27.0263C34.7093 26.9751 34.8795 26.8271 34.9591 26.6289C35.3446 25.7034 35.5877 24.7248 35.6803 23.7265C35.6807 23.6723 35.6742 23.6182 35.6609 23.5656C35.5668 23.1773 35.3398 22.8342 35.0191 22.5959L35.0297 19.0719C35.0361 16.9304 34.3848 16.0497 33.6977 15.5385C33.5693 14.5066 32.4709 12.4176 28.4032 12.4053C24.7939 12.5398 21.8928 15.4234 21.7366 19.0319L21.726 22.556C21.4039 22.7923 21.1747 23.1341 21.0783 23.5218C21.0647 23.5743 21.0579 23.6283 21.0579 23.6825C21.1444 24.6819 21.3816 25.6623 21.7617 26.5906C21.8187 26.7786 21.9692 26.9236 22.1593 26.9733C22.2337 27.0108 22.3727 27.204 22.3713 27.6746C22.5359 29.0826 23.2354 30.3735 24.3252 31.2803C24.183 32.1505 23.5273 34.4443 22.1391 35.0197L16.2324 36.9613C14.7202 37.4597 13.57 38.6997 13.1863 40.2449L12.3791 43.4329C12.2878 43.7884 12.5019 44.1507 12.8574 44.2421C12.9105 44.2558 12.9652 44.2628 13.02 44.263L43.5943 44.3551C43.9614 44.3561 44.2598 44.0593 44.2608 43.6922C44.2609 43.638 44.2544 43.584 44.2415 43.5314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_95",
    x1: 28.9916,
    y1: -1.49549,
    x2: 25.9021,
    y2: 51.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2578E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9037,
    height: 31.9037,
    fill: "white",
    transform: "translate(12.4515 12.3573) rotate(0.172581)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarupload);
export default __webpack_public_path__ + "static/media/avatarupload.bf3996341aee9fff9a7c221e8933e5bf.svg";
export { ForwardRef as ReactComponent };